module.exports = __webpack_public_path__ + "img/bingo_ball-36.1fe4b738.png";